/*
 * Copyright (c) 2020. Legalbird eine Marke der R&S Internet Jewels GmbH
 */

import React from "react";
import Container from "@/src/components/Container/Container";
import AttorneySectionHeadings from "./AttorneySectionHeadings";
import BirdMapSection from "@/src/components/Sections/Divorce/BirdMapSection/BirdMapSection";
import TeamSection from "@/src/components/Sections/Generic/TeamSection/TeamSection";
import { Box } from "@mui/material";

type AttorneySectionProps = {
  product?: "divorce" | "settlement" | "traffic" | "familyLawCase" | "contract" | "trafficAccident";
  heading?: string;
  subheading?: string;
};

const AttorneySection = ({ product = "divorce", heading, subheading }: AttorneySectionProps) => {
  return (
    <>
      <Container>
        <Box id="partneranwaelte">
          {" "}
        </Box>
        <AttorneySectionHeadings heading={heading} subheading={subheading} />
      </Container>
      {/*teamsection needs to be outside of container because the cards overlap if theres not enough width*/}
      {product === "settlement" ? (
        <TeamSection
          showHeadings={false}
          headline={"Sie möchten professionell gegen Ihre Kündigung angehen?"}
          subHeadline={"Wir kümmern uns persönlich um Sie"}
        />
      ) : (
        <TeamSection isSubsection={true} headline={"Wir kümmern uns persönlich um Sie"} />
      )}
      <Container>
        <BirdMapSection />
      </Container>
    </>
  );
};

export default AttorneySection;
